import { DependencyList, useCallback, useRef } from "react"

export const useOnElementVisible = (callback: () => void, deps: DependencyList) => {
  const observer = useRef<IntersectionObserver | null>(null)
  return useCallback(
    (node: HTMLElement | null) => {
      if (observer.current) observer.current.disconnect()
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && callback) callback()
      })
      if (node) observer.current.observe(node)
    },
    [deps],
  )
}
